<phito-key-value-list title="Dokumentationen">
    @for (docu of documentations(); track docu.id; let i = $index) {
    <phito-key-value-list-item icon="book_2" [key]="(i+1) + '. Dokumentation'" [value]="docu.title"
        actionButtonIcon="open_in_new" (actionClicked)="openDocumentation(docu)"></phito-key-value-list-item>
    }
</phito-key-value-list>